import React from 'react';
import styled from 'styled-components';

import { theme } from 'components';

import HeaderText from './HeaderText';

type TaskLayoutProps = {
  title: string;
  content?: React.ReactNode;
  buttons: React.ReactNode;
  dataCy?: string;
};

const TaskLayout: React.FC<TaskLayoutProps> = ({
  title,
  content,
  buttons,
  dataCy,
}) => (
    <TaskLayoutContainer data-cy={dataCy}>
      <HeaderText level={5}>{title}</HeaderText>
      <ContentContainer>{content}</ContentContainer>
      {buttons}
    </TaskLayoutContainer>
  );

export default TaskLayout;

export const TaskLayoutContainer = styled.div`
  padding: 16px;
`;

export const ContentContainer = styled.div`
  border-left: 1px solid ${theme.gray4};
  padding-left: 18px;
  margin: 12px 0;

  color: ${theme.gray7};
  font-size: 12px;
`;
